import { Text, Link, VStack } from "@postenbring/hedwig-react";

const SearchResult = ({ units, noResultMessage, mapLabel, mapUrl }) => {
    const ShowUnits = () => (
        <VStack gap="12">
            {units.map((unit) => (
                <div key={unit.number}>
                    <Text variant="body-title">{unit.name}</Text>
                    <Text>{unit.number}</Text>
                    <Text>{unit.location}</Text>
                    <Text>
                        {unit.address}, {unit.postCode} {unit.city}
                    </Text>
                    <Link href={`${mapUrl}?ID=${unit.number}`} target="_blank">
                        {mapLabel}
                    </Link>
                </div>
            ))}
        </VStack>
    );

    if (units.length > 0) {
        return <ShowUnits />;
    } else {
        return <Text>{noResultMessage}</Text>;
    }
};

export default SearchResult;
